module.exports = __webpack_public_path__ + "static/media/img3.dc4cbb43.jpg";